export default (element) => {
  const menuListButtons = element.querySelectorAll('[data-footer-menu-list-title]');

  const menuLinkToggle = () => {
    menuListButtons.forEach((listItem) => listItem.addEventListener('click', () => {
      listItem.lastElementChild.classList.toggle('rotate-180');
      listItem.nextElementSibling.classList.toggle('hidden');
    }));
  };

  const init = () => {
    menuLinkToggle();
  };
  init();
};
